import { useState } from "react";

const tierColor = (value) => {
    if (value >= 15) return { bar: "from-emerald-500 to-teal-500", chip: "bg-emerald-50 text-emerald-700" };
    if (value >= 7) return { bar: "from-amber-500 to-orange-500", chip: "bg-amber-50 text-amber-700" };
    return { bar: "from-rose-500 to-pink-500", chip: "bg-rose-50 text-rose-700" };
};

const ConversionRanking = ({ data }) => {

    const [expanded, setExpanded] = useState(false);
    const limit = 6;
    const sorted = [...data].sort(
        (a, b) => b.conversion - a.conversion
    );
    const remaining = Math.max(sorted.length - limit, 0);
    const visible = expanded ? sorted : sorted.slice(0, limit);

    return (
        <div className="rounded-xl border border-slate-200 bg-gradient-to-br from-violet-50/40 to-white p-5">
            <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
                <div>
                    <h2 className="text-sm font-semibold text-slate-900">Conversion Rate</h2>
                    <p className="text-xs text-slate-500">Highest converting sources</p>
                </div>

                <div className="flex items-center gap-3 text-[11px] text-slate-400">
                    <span className="flex items-center gap-1">
                        <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" /> ≥15%
                    </span>
                    <span className="flex items-center gap-1">
                        <span className="h-1.5 w-1.5 rounded-full bg-amber-500" /> ≥7%
                    </span>
                    <span className="flex items-center gap-1">
                        <span className="h-1.5 w-1.5 rounded-full bg-rose-500" /> &lt;7%
                    </span>
                </div>
            </div>

            <div className={`space-y-3 px-4 pb-4 ${expanded ? "max-h-80 overflow-y-auto" : ""}`} >
                {visible.map((item, i) => {
                    const t = tierColor(item.conversion);
                    return (
                        <div key={item.source} className="flex items-center gap-2.5">
                            <span className="w-4 shrink-0 text-[11px] font-semibold text-slate-400">
                                {i + 1}
                            </span>

                            <div className="min-w-0 flex-1">
                                <div className="mb-1 flex items-center justify-between gap-2 text-xs">
                                    <span className="truncate font-medium text-slate-700" title={item.source}>
                                        {item.source}
                                    </span>
                                    <span className={`shrink-0 rounded-full px-1.5 py-0.5 text-[11px] font-semibold ${t.chip}`}>
                                        {item.conversion}%
                                    </span>
                                </div>

                                <div className="h-1.5 overflow-hidden rounded-full bg-slate-100">
                                    <div
                                        className={`h-full rounded-full bg-gradient-to-r ${t.bar}`}
                                        style={{ width: `${Math.min(item.conversion, 100)}%` }}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
                {(remaining > 0 || expanded) && (
                    <button
                        type="button"
                        onClick={() => setExpanded(!expanded)}
                        className="w-full pt-2 text-center text-[11px] font-medium text-indigo-600 hover:text-indigo-700"
                    >
                        {expanded ? "Show Less" : `+${remaining} more`}
                    </button>
                )}
            </div>
        </div>
    );
};

export default ConversionRanking;